import locales from './locales';
import registerToggle from './registerToggle';
import users from './users';
import basketToggle from './basketToggle';
import callToggle from './callToggle';
import homePage from './homePage';
import aboutPage from './aboutPage';
import laboratoryPage from './laboratoryPage';
import diagnosticPage from './diagnosticPage';
import contactPage from './contactPage';
import certificatesPage from './certificatesPage';
import addressesPage from './addressesPage';
import careerPage from './careerPage';
import footerData from './footerData';
import headerData from './headerData';
import translation from './translation';
import blogPage from './blogPage';
import socialLinks from './socialLinks';
import sendFiatBack from './sendFiatBack';
import basketReducers from './basketReducers';
import expiredReducer from './expiredReducer';
import points from './points';
import checkOutReducer from './checkOutReducer';
import partnersPage from './partnersPage';
import userAccount from './userAccount';
import getDoctor from './getDoctor';
import anyReducer from './anyReducer';
import getService from './getService';
import getArticle from './getArticle';
import faqPage from './faqPage';
import newsPage from './newsPage';
import privacyPage from './privacyPage';
import menuToggle from './menuToggle';
import comprehensivePage from './comprehensivePage';
import giftToggle from './giftToggle';

export default {
  locales,
  registerToggle,
  users,
  basketToggle,
  callToggle,
  homePage,
  aboutPage,
  laboratoryPage,
  diagnosticPage,
  contactPage,
  certificatesPage,
  addressesPage,
  careerPage,
  footerData,
  headerData,
  translation,
  blogPage,
  socialLinks,
  sendFiatBack,
  basketReducers,
  expiredReducer,
  points,
  checkOutReducer,
  partnersPage,
  userAccount,
  getDoctor,
  anyReducer,
  getService,
  getArticle,
  faqPage,
  newsPage,
  privacyPage,
  menuToggle,
  comprehensivePage,
  giftToggle,
};
